import { redirect } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api.ts";
import { AdminPanelTagData } from "@/routes/adminPanel/tags/main/types/adminPanelTagData.ts";

export const adminPanelTagEditAction = async ({
  request,
}: {
  request: Request;
}) => {
  const formData = await request.formData();
  const data = Object.fromEntries(formData) as unknown as AdminPanelTagData;
  try {
    const url = new URL(request.url);
    const returnUrl = url.searchParams.get("returnUrl") || "/admin-panel/tags";
    const tagUpdateResult = await apiEndpoints.updateTag(data);
    if (tagUpdateResult) {
      return redirect(returnUrl);
    }
    return true;
  } catch (err) {
    throw err;
  }
};
